import { cartesianBeamOverlapsWall } from '@geometry'
import { groupBy } from 'lodash-es'

export interface BeamWallOverlapGuids {
  wallGuids: Set<string>
  beamGuids: Set<string>
}

export const getBeamWallOverlapGuids = (
  walls: ShapeObject[],
  beams: ShapeObjectLine[],
): BeamWallOverlapGuids => {
  const wallsByStorey = groupBy(walls, 'storey')
  const beamsByStorey = groupBy(beams, 'storey')
  const wallGuids = new Set<string>()
  const beamGuids = new Set<string>()

  Object.entries(wallsByStorey).forEach(([storey, storeyWalls]) => {
    const storeyBeams = beamsByStorey[storey] ?? []

    storeyWalls.forEach(wall => {
      storeyBeams.forEach(beam => {
        if (cartesianBeamOverlapsWall(beam, wall)) {
          wallGuids.add(wall.guid)
          beamGuids.add(beam.guid)
        }
      })
    })
  })

  return { wallGuids, beamGuids }
}
